import { getDealerById } from '../../api/dealers'

// запрос на получение информации о дилере (адрес, название)
export const getDealerInfoById = async (dealerId: string, url: string) => {
  const formedUrl = process.env.NODE_ENV === 'development' ? url + dealerId : document.location.origin + url + dealerId
  const { attributes } = await getDealerById(formedUrl)

  return attributes
}
